const threeProps = {
  marker: {
    dot: {
      radius: 0.04,
      material: {
        color: 0x011dff,
      },
    },
    triangle: {
      material: {
        color: 0x32ba19,
      },
    },
  },
  globe: {
    radius: 10,
    material: {
      color: 0xffffff,
      wireframe: false,
    },
    segments: {
      w: 64,
      h: 64,
    },
    viewTransitionDuration: 1,
    landingDuration: 4,
    startPosition: {
      x: 0,
      y: -12,
      z: 28,
    },
    finalPosition: {
      x: 0,
      y: 0,
      z: 0,
    },
  },
  pointGlobe: {
    radius: 10,
    material: {
      color: 0xffffff,
      wireframe: true,
    },
    segments: {
      w: 32,
      h: 32,
    },
  },
  camera: {
    fov: 45,
    near: 1,
    far: 100,
    pos: {
      x: 0,
      y: 0,
      z: 45,
    },
  },
}

export default threeProps
